import client from '../ApolloClient'
import gql from 'graphql-tag'
import { failFetch } from '../Actions/Other'
// eslint-disable-next-line
import { Observable, Subject, filter, mergeMap, map } from 'rxjs'

import { FETCH_MONTHLY_ACTIVE_USERS, loadMonthlyActiveUsers } from '../Actions/MonthlyActiveUsers'

const monthlyActiveUsersQuery = gql`query getMonthlyActiveUsers($accountId: String!, $appProfileIds: [ID!], $groupIds: [ID!]) {
  getMonthlyActiveUsers(accountId: $accountId, appProfileIds: $appProfileIds, groupIds: $groupIds) {
    unregisteredCount
    inactiveCount
    activeCount
    account
    month
    year
  }
}`

/**
  * monthlyActiveUsersEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch monthly active users action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const monthlyActiveUsersEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_MONTHLY_ACTIVE_USERS),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: monthlyActiveUsersQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadMonthlyActiveUsers(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
